
 
let section3 = [
	//require('../../../images/success/e1.jpg'),
	//require('../../../images/success/e2.jpg'),
	require('../../../images/success/e3.jpg'),
]


export {section3}